import { InjectionToken } from '@angular/core';
import { BookableServicesDataService } from '../repositories/bookable-services-data.service';

export const BOOKABLE_SERVICES_DATA_SERVICE =
  new InjectionToken<BookableServicesDataService>(
    'BOOKABLE_SERVICES_DATA_SERVICE'
  );
